import { render, staticRenderFns } from "./LessonTuoyu.vue?vue&type=template&id=6631efac&scoped=true&"
import script from "./LessonTuoyu.vue?vue&type=script&lang=js&"
export * from "./LessonTuoyu.vue?vue&type=script&lang=js&"
import style0 from "./LessonTuoyu.vue?vue&type=style&index=0&id=6631efac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6631efac",
  null
  
)

export default component.exports